import React, {
  ChangeEvent, useState,
} from 'react';
import MUITextField from '@mui/material/TextField';

interface Props {
  hidden?: boolean,
  disabled: boolean;
  value: { textValue: string };
  label: string;
  min: number;
  max: number;
  required: boolean;
  onChange(newVal: { textValue: string }): void;
}

const NumberField: React.FC<Props> = ({
  hidden = false,
  disabled,
  value,
  label,
  min,
  max,
  required,
  onChange,
}: Props) => {
  const [textValue, setTextValue] = useState<string>(value.textValue || '');

  const handleChange = (event: ChangeEvent<HTMLInputElement>): void => {
    const inputValue = event.target.value;

    setTextValue(inputValue);
    onChange({ textValue: inputValue });
  };

  return (
    <>
      {!hidden && (
        <MUITextField
          variant="outlined"
          inputProps={{
            inputMode: 'numeric',
            pattern: '[0-9]*',
            min,
            max,
          }}
          value={textValue}
          onChange={handleChange}
          label={label}
          required={required}
          disabled={disabled}
          fullWidth
        />
      )}
    </>
  );
};

export default NumberField;
